/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, Mixins } from 'vue-property-decorator';
import { Cell, CellGroup } from 'vant';
import { NoticeBar } from '@hb/coffee';
import LegalAgreementsMixins from '@/mixins/legal-agreements';
import { ContractData } from '@/api/contract/types';
import { ContractItem, openContract } from '@/ContractConfig';
import { setPageTitle } from '@/api/native/utils';


const style: Dictionary = require('./index.module.scss');

@Component({ name: 'ChannelConstract' })
export default class ChannelConstract extends Mixins(LegalAgreementsMixins) {
  private creditAgreementInfo: ContractData[]= [Object.create(null)]

  private get currentProductId() {
    return Number(this.$route.query.productId);
  }

  private async created() {
    const routerName = this.$route.query.productName;
    setPageTitle(routerName);
    this.creditAgreementInfo = await this.creditAgreement(this.currentProductId, 'myPage');
  }

  private onCheckChannleConstract(item: ContractData) {
    openContract(item as ContractItem);
  }

  private render() {
    return (
      <div class={style.ChannelConstract}>
          <NoticeBar
            type="primary"
            show-arrow={false}
            text-wrap
            text={'你所获得的授信以实际资金方审核结果为准，本平台仅负责信息展示'}/>
        <CellGroup>
          {this.creditAgreementInfo
            && this.creditAgreementInfo.map(
              (item: ContractData) => <Cell
              title={item.name}
              isLink
              onClick={() => this.onCheckChannleConstract(item)
              }
              key={item.forceRead}
            >
              <span slot="right-icon" class={style.rightIcon} />
            </Cell>,
            )}
        </CellGroup>
      </div>
    );
  }
}
